import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorContentBlogView = () => {
  const blogView = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/content-blog/view', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { blogView }
}

export default InteractorContentBlogView
